export const restVisor = {
    data() {
        return {
            mapsAssignedToUserID: []
        }
    },
    methods: {
        getMapsAssigned: function(){
            var that = this;
            this.$http.get(this.$store.getters.backendurl + 'api/v1/visor/maps')
            .then(function (response) {
                that.mapsAssignedToUserID = response.data;
                console.log('maps', that.mapsAssignedToUserID)
            })
            .catch(function (error) {
                console.log(error)
                //El mensaje del backend es texto interno en ingles ("This is secret
                //and you can't see it...") y termina en pantalla tal cual. Lo que el
                //usuario necesita saber es que no se pudieron cargar sus mapas.
                that.message = 'No fue posible cargar los mapas asignados.';
            });
        },
        getLayersAssigned: function(idMap){
            var that = this;
            return this.$http.get(this.$store.getters.backendurl + 'api/v1/visor/maps/' + idMap + '/layers' )
            .then(function (response) {
                console.log("CHAO", response)
                that.$store.dispatch('setLayers', response.data)
            })
            .catch(function (error) {
                console.log(error)
                that.message = error.response.data.message;
            });
        },
        getGeoprocessingsAssigned: function(idMap){
            var that = this;
            this.$http.get(this.$store.getters.backendurl + 'api/v1/visor/maps/' + idMap + '/geoprocessings' )
            .then(function (response) {
                that.$store.dispatch('setGeoprocessings', response.data)
            })
            .catch(function (error) {
                console.log(error)
                that.message = error.response.data.message;
            });
        },
        // Herramientas habilitadas del mapa (QA-11). null = todas.
        getToolsAssigned: function(idMap){
            var that = this;
            this.$http.get(this.$store.getters.backendurl + 'api/v1/visor/maps/' + idMap + '/tools' )
            .then(function (response) {
                that.$store.dispatch('setEnabledMapTools', response.data)
            })
            .catch(function (error) {
                // Si la consulta falla se deja el menú completo: mejor mostrar
                // una herramienta de más que dejar el visor sin menú.
                console.log(error)
            });
        }
    }
}